/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/
/* eslint @typescript-eslint/no-inferrable-types: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-non-null-assertion: 0 */

import { AxiosResponse } from "axios";

export default class ReturnData<T = any> {
	private _code: string = "";
	private _status: number = 200;
	private _data: T | null = null;
	private _message: string = "";
	private _domain: string = "";
	private _parameter: any;

	constructor(result?: AxiosResponse<ReturnDataType, T>) {
		if (result) {
			this._status = result.status;
			this._data = result.data as unknown as T;
			this._domain = result.config.baseURL!;
			// if (has(result, "code")) {
			// 	this._code = data.code || "40100";
			// 	this._data = data.data as T;
			// 	this._message = data.message || "";
			// 	this._domain = data.domain || Properties.property.apiDomain;
			// } else {
			// 	this._code = "40100";
			// 	this._data = data as T;
			// 	this._message = "";
			// 	this._domain = Properties.property.apiDomain;
			// }
		} else {
			this._code = "40999";
			this._message = "DATA is empty";
		}
	}

	public get code() {
		return this._code;
	}
	public get status() {
		return this._status;
	}
	public get isSuccess() {
		if (this.code.length) {
			return this.code === "40100";
		} else {
			return this.status === 200;
		}
	}
	public get message() {
		return this._message;
	}
	public get data(): T {
		// if (!this._data) {
		// 	throw new Error("Data is empty or null");
		// }
		return this._data!;
	}
	public get apiDomain() {
		return this._domain;
	}

	public get parameter() {
		return this._parameter;
	}
	public set parameter(value: any) {
		this._parameter = value;
	}
}
